
// 通用跳转方法
export function jprouter() {
	window.open( 'http://www.dixcel.co.jp/' , '_blank' )
}
export function enrouter() {
	window.open( 'http://www.dixcel.co.jp/en/' , '_blank' )
}
export function weiborouter() {
	window.open( 'https://weibo.com/dixcelchina' , '_blank' )
}
export function beian() {
	window.open( 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011402002302' , '_blank' )
}
export function beianmiit() {
	window.open( 'https://beian.miit.gov.cn' , '_blank' )
}
